import React, { useState } from 'react';
import { Container, Row, Col, Nav, Tab, Card, Button, Alert, ProgressBar, Accordion } from 'react-bootstrap';

import '../App.css';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import logo from "../images/geointelli-q.png"
function FirstPage() {

  const [showWelcome, setShowWelcome] = useState(true);

  const energyData = [
    { name: 'Jan', Solar: 4000, Wind: 2400, Hydro: 2400 },
    { name: 'Feb', Solar: 3000, Wind: 1398, Hydro: 2210 },
    { name: 'Mar', Solar: 2000, Wind: 9800, Hydro: 2290 },
    { name: 'Apr', Solar: 2780, Wind: 3908, Hydro: 2000 },
    { name: 'May', Solar: 1890, Wind: 4800, Hydro: 2181 },
    { name: 'Jun', Solar: 2390, Wind: 3800, Hydro: 2500 },
    { name: 'Jul', Solar: 3490, Wind: 4300, Hydro: 2100 },
  ];

  return (
    <div className="app-container">
     

      {/* Main Content */}
      <Container className="py-5">
        {showWelcome && (
          <Alert variant="info" onClose={() => setShowWelcome(false)} dismissible>
            <Alert.Heading>Welcome to Quantum-Energy Nexus Platform</Alert.Heading>
            <p>
              This platform demonstrates the integration of Quantum Computing and AI for renewable energy optimization.
              Explore the various sections to learn more about our innovative approach.
            </p>
          </Alert>
        )}

        <Tab.Container id="main-tabs" defaultActiveKey="overview">
          <Row>
            <Col md={3} className="mb-4">
              <Nav variant="pills" className="flex-column sidebar">
                <Nav.Item>
                  <Nav.Link eventKey="overview">Overview</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="model">Quantum Network Model</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                <Nav.Link eventKey="company">Our Software</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="methodology">Methodology</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="computing">Computing Methods</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="application">Software Application</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="future">Future Prospects</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="challenges">Challenges</Nav.Link>
                </Nav.Item>
              </Nav>
              
              {/* <Card className="mt-4">
                <Card.Header>Project Status</Card.Header>
                <Card.Body>
                  <p>Research Progress</p>
                  <ProgressBar variant="success" now={65} label={`65%`} />
                  <p className="mt-3">Implementation</p>
                  <ProgressBar variant="info" now={40} label={`40%`} />
                </Card.Body>
              </Card> */}
            </Col>
            
            <Col md={9}>
              <Tab.Content>
                <Tab.Pane eventKey="overview">
                  <h2>Introduction</h2>
                  <p>
                    The transition to renewable energy requires advanced computational models to optimize power generation, 
                    distribution, and storage. Traditional energy models often struggle with scalability, real-time adaptability, 
                    and efficiency. Quantum computing, integrated with AI-driven network models, offers a revolutionary approach 
                    to renewable energy simulations and optimization.
                  </p>
                  <p>
                    This research presents the Quantum-Energy Nexus, an AI-powered Quantum Network Model that leverages 
                    Quantum Intelligence, AI-driven predictive analytics, and network-based quantum computing to enhance 
                    renewable energy systems.
                  </p>
                  
                  <h3 className="mt-4">Energy Distribution Overview</h3>
                  <div className="chart-container">
                    <ResponsiveContainer width="100%" height={300}>
                      <LineChart data={energyData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="Solar" stroke="#8884d8" />
                        <Line type="monotone" dataKey="Wind" stroke="#82ca9d" />
                        <Line type="monotone" dataKey="Hydro" stroke="#ffc658" />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Tab.Pane>

<Tab.Pane eventKey="company">
  <h2>Our Software & Company</h2>
  <p>
    The Quantum-Energy Nexus software represents our company's flagship solution 
    for renewable energy optimization using quantum computing and AI.
  </p>
  
  <Row className="mt-5 align-items-center">
    <Col md={5}>
      <div className="software-image-container">
        <img 
          src={logo} 
          alt="Quantum-Energy Nexus Software" 
          className="img-fluid m-1 p-3 rounded shadow " 
        />
      </div>
    </Col>
    <Col md={7}>
      <h3>Company Overview</h3>
      <p>
        <strong>Olewin</strong> is a pioneering force in quantum computing solutions 
        for sustainable energy. Founded by Bandaru Mahesh, we focus on bridging the gap between 
        advanced quantum algorithms and real-world energy challenges.
      </p>
      <h4 className="mt-4">Our Mission</h4>
      <p>
        To revolutionize renewable energy management through quantum-enhanced 
        optimization, making sustainable energy more efficient, accessible, and reliable.
      </p>
      {/* <div className="d-flex mt-4">
        <Button variant="primary" className="me-3"> <a className='text-light' href="https://olewingroup.com/" target='_blank' rel='noreferrer'>Company Website</a>...</Button>
        <Button variant="dark"><a className='text-light ' href="https://olewintechsolutions.com/" target='_blank' rel='noreferrer'>Developer Website</a>...</Button>
      </div> */}
    </Col>
  </Row>
  
  <h3 className="mt-5">Software Features</h3>
<Row className="mt-4">
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-graph-up"></i>
      </div>
      <Card.Body>
        <Card.Title>Real-time Analytics</Card.Title>
        <Card.Text>
          Quantum-powered real-time analysis of energy production and consumption patterns with geological formation assessment capabilities.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-cpu"></i>
      </div>
      <Card.Body>
        <Card.Title>Quantum Optimization Engine</Card.Title>
        <Card.Text>
          Proprietary algorithms that optimize energy distribution and geological resource planning with QML Model.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-cloud-arrow-up"></i>
      </div>
      <Card.Body>
        <Card.Title>Cloud Integration</Card.Title>
        <Card.Text>
          Seamless cloud-based deployment for scalable energy management with geological data repositories.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-map"></i>
      </div>
      <Card.Body>
        <Card.Title>Structural Geology Analysis</Card.Title>
        <Card.Text>
          Comprehensive mapping and analysis of rock formations, faults, folds, and tectonic structures with 3D visualization.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-layers"></i>
      </div>
      <Card.Body>
        <Card.Title>Stratigraphic Modeling</Card.Title>
        <Card.Text>
          Advanced modeling of sedimentary layers with chronostratigraphic correlation and sequence stratigraphy analysis.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-tsunami"></i>
      </div>
      <Card.Body>
        <Card.Title>Seismic Data Processing</Card.Title>
        <Card.Text>
          AI-enhanced interpretation of seismic survey data for accurate fault detection and reservoir characterization.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-bar-chart-line"></i>
      </div>
      <Card.Body>
        <Card.Title>Petrophysical Analysis</Card.Title>
        <Card.Text>
          Automated core sample analysis and well log interpretation for comprehensive formation evaluation.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-droplet-fill"></i>
      </div>
      <Card.Body>
        <Card.Title>Hydrogeology Simulation</Card.Title>
        <Card.Text>
          Advanced modeling of groundwater flow, aquifer properties, and contaminant transport with remediation planning.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-thermometer-high"></i>
      </div>
      <Card.Body>
        <Card.Title>Geothermal Analysis</Card.Title>
        <Card.Text>
          Identification and evaluation of geothermal energy sources through temperature gradient modeling and heat flow analysis.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-gem"></i>
      </div>
      <Card.Body>
        <Card.Title>Mineralogy & Petrology</Card.Title>
        <Card.Text>
          Digital identification of minerals and rocks with composition analysis and petrographic visualization tools.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-clock-history"></i>
      </div>
      <Card.Body>
        <Card.Title>Geochronology Tools</Card.Title>
        <Card.Text>
          Dating simulation for various geological materials using radiometric, luminescence, and stable isotope methodologies.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-globe"></i>
      </div>
      <Card.Body>
        <Card.Title>Plate Tectonics Simulator</Card.Title>
        <Card.Text>
          Reconstruction of tectonic plate movements through geological time with prediction modeling and rift analysis.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-geo-alt"></i>
      </div>
      <Card.Body>
        <Card.Title>Paleontology Database</Card.Title>
        <Card.Text>
          Comprehensive fossil record management with taxonomic identification and paleoenvironmental reconstruction tools.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-tsunami"></i>
      </div>
      <Card.Body>
        <Card.Title>Geohazard Assessment</Card.Title>
        <Card.Text>
          Predictive modeling for earthquakes, landslides, volcanic eruptions, and flooding with early warning system integration.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-water"></i>
      </div>
      <Card.Body>
        <Card.Title>Marine Geology Tools</Card.Title>
        <Card.Text>
          Seafloor mapping, coastal process modeling, and submarine geological feature identification with bathymetric visualization.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-droplet-half"></i>
      </div>
      <Card.Body>
        <Card.Title>Geochemical Modeling</Card.Title>
        <Card.Text>
          Simulation of fluid-rock interactions, isotope fractionation, and hydrocarbon maturation with predictive analytics.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-moon-stars"></i>
      </div>
      <Card.Body>
        <Card.Title>Planetary Geology</Card.Title>
        <Card.Text>
          Comparative analysis of extraterrestrial geological processes with Earth analogues and meteorite composition studies.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  <Col md={4} className="mb-4">
    <Card className="feature-card h-100">
      <div className="feature-icon">
        <i className="bi bi-fuel-pump"></i>
      </div>
      <Card.Body>
        <Card.Title>Petroleum System Analysis</Card.Title>
        <Card.Text>
          Integrated modeling of source rock, migration pathways, reservoir properties, and trap formation for oil and gas exploration.
        </Card.Text>
      </Card.Body>
    </Card>
  </Col>
</Row>
  
  {/* <div className="company-stats mt-5 p-4">
    <Row>
      <Col md={3} className="text-center">
        <div className="stat-number">7 +</div>
        <div className="stat-label">Years Experience</div>
      </Col>
      <Col md={3} className="text-center">
        <div className="stat-number">170 K+</div>
        <div className="stat-label">Github Contributions</div>
      </Col>
      <Col md={3} className="text-center">
        <div className="stat-number">200+</div>
        <div className="stat-label">Github Projects</div>
      </Col>
      <Col md={3} className="text-center">
        <div className="stat-number">100 %  </div>
        <div className="stat-label">Success Rate</div>
      </Col>
     
    
    </Row>
  </div> */}
</Tab.Pane>
                
                <Tab.Pane eventKey="model">
                  <h2>Quantum Network Model for Renewable Energy</h2>
                  <p>
                    The Quantum-Energy Nexus employs Quantum Network Models (QNM) to simulate and optimize solar, wind, 
                    and hydropower systems. The key components of the model include:
                  </p>
                  
                  <Row className="mt-4">
                    <Col md={4}>
                      <Card className="h-100">
                        <Card.Body>
                          <Card.Title>Quantum Graph Networks (QGN)</Card.Title>
                          <Card.Text>
                            For high-dimensional representation of energy flow and distribution.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card className="h-100">
                        <Card.Body>
                          <Card.Title>Quantum-Assisted Optimization</Card.Title>
                          <Card.Text>
                            Enhancing grid stability, storage management, and real-time power distribution.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card className="h-100">
                        <Card.Body>
                          <Card.Title>AI-Quantum Hybrid Learning</Card.Title>
                          <Card.Text>
                            Integrating Quantum Machine Learning (QML) with classical AI models for enhanced accuracy.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Tab.Pane>
                
                <Tab.Pane eventKey="methodology">
                  <h2>Methodology</h2>
                  <p>
                    The proposed framework follows a structured approach:
                  </p>
                  
                  <Accordion defaultActiveKey="0" className="mt-4">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Data Acquisition & Processing</Accordion.Header>
                      <Accordion.Body>
                        Collection of renewable energy datasets, including solar radiation, wind speeds, and hydropower inflow.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Quantum Algorithm Implementation</Accordion.Header>
                      <Accordion.Body>
                        Application of Quantum Annealing (QA), Variational Quantum Eigensolver (VQE), and Grover's Algorithm for energy optimization.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>AI-Driven Predictive Modeling</Accordion.Header>
                      <Accordion.Body>
                        Utilizing deep learning and reinforcement learning to enhance forecasting and real-time adaptability.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>Quantum Simulation & Validation</Accordion.Header>
                      <Accordion.Body>
                        Conducting quantum-based simulations for grid optimization, load balancing, and energy trading models.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Tab.Pane>
                
                <Tab.Pane eventKey="computing">
                  <h2>Computing Methods</h2>
                  <p>
                    The computational backbone of this research integrates:
                  </p>
                  
                  <Row className="mt-4">
                    <Col md={4} className="mb-4">
                      <Card className="text-center h-100">
                        <Card.Body>
                          <i className="bi bi-cpu display-4"></i>
                          <Card.Title className="mt-3">Hybrid Quantum-Classical Computing</Card.Title>
                          <Card.Text>
                            Using IBM Qiskit, Google Cirq, and D-Wave systems for quantum simulations.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={4} className="mb-4">
                      <Card className="text-center h-100">
                        <Card.Body>
                          <i className="bi bi-braces display-4"></i>
                          <Card.Title className="mt-3">AI Frameworks</Card.Title>
                          <Card.Text>
                            Leveraging TensorFlow, PyTorch, and SciPy for predictive modeling and reinforcement learning.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={4} className="mb-4">
                      <Card className="text-center h-100">
                        <Card.Body>
                          <i className="bi bi-cloud display-4"></i>
                          <Card.Title className="mt-3">Cloud & Edge Computing</Card.Title>
                          <Card.Text>
                            Implementing cloud-based distributed computing environments for real-time energy data analysis.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Tab.Pane>
                
                <Tab.Pane eventKey="application">
                  <h2>Software Application Development</h2>
                  <p>
                    A dedicated Quantum-Energy Optimization Software is under development to integrate the proposed framework into practical applications. Key features include:
                  </p>
                  
                  <Row className="mt-4">
                    <Col md={6} className="mb-4">
                      <Card className="h-100">
                        <Card.Body>
                          <Card.Title>Real-time Quantum-Assisted Energy Forecasting</Card.Title>
                          <Card.Text>
                            Utilize quantum algorithms to predict energy production and consumption patterns with unprecedented accuracy.
                          </Card.Text>
                          <Button variant="outline-primary">Learn More</Button>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Card className="h-100">
                        <Card.Body>
                          <Card.Title>Smart Grid Optimization & Load Balancing</Card.Title>
                          <Card.Text>
                            Implement quantum-enhanced algorithms for optimal energy distribution and grid management.
                          </Card.Text>
                          <Button variant="outline-primary">Learn More</Button>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Card className="h-100">
                        <Card.Body>
                          <Card.Title>Renewable Energy Trading Models</Card.Title>
                          <Card.Text>
                            Develop AI-Quantum hybrid approaches for efficient energy trading and market optimization.
                          </Card.Text>
                          <Button variant="outline-primary">Learn More</Button>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Card className="h-100">
                        <Card.Body>
                          <Card.Title>Scalable Cloud-Based Quantum Computing Framework</Card.Title>
                          <Card.Text>
                            Build a robust infrastructure for deploying quantum algorithms in renewable energy applications.
                          </Card.Text>
                          <Button variant="outline-primary">Learn More</Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Tab.Pane>
                
                <Tab.Pane eventKey="future">
                  <h2>Future Prospects</h2>
                  <p>
                    The Quantum-Energy Nexus framework opens new possibilities for:
                  </p>
                  
                  <Row className="mt-4">
                    <Col md={6} className="mb-4">
                      <Card className="h-100 bg-light">
                        <Card.Body>
                          <Card.Title>Ultra-Efficient Renewable Energy Grids</Card.Title>
                          <Card.Text>
                            Self-learning optimization systems that continuously improve energy distribution and consumption patterns.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Card className="h-100 bg-light">
                        <Card.Body>
                          <Card.Title>Decentralized AI-Quantum Energy Networks</Card.Title>
                          <Card.Text>
                            Autonomous power distribution systems that adapt to changing environmental and consumption patterns.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Card className="h-100 bg-light">
                        <Card.Body>
                          <Card.Title>Enhanced Battery & Storage Optimization</Card.Title>
                          <Card.Text>
                            Quantum-enhanced algorithms for optimal energy storage and utilization across diverse storage technologies.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Card className="h-100 bg-light">
                        <Card.Body>
                          <Card.Title>Quantum-Driven Policy Recommendations</Card.Title>
                          <Card.Text>
                            Data-driven insights for sustainable energy transitions and policy development.
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Tab.Pane>
                
                <Tab.Pane eventKey="challenges">
                  <h2>Challenges & Limitations</h2>
                  <p>
                    Despite its potential, this research faces several challenges:
                  </p>
                  
                  <Card className="mt-4 mb-4">
                    <Card.Header>Hardware Limitations</Card.Header>
                    <Card.Body>
                      <Card.Text>
                        Current quantum computers are still in the NISQ (Noisy Intermediate-Scale Quantum) era, affecting scalability.
                      </Card.Text>
                      <ProgressBar variant="danger" now={70} label="Challenge Level" />
                    </Card.Body>
                  </Card>
                  
                  <Card className="mb-4">
                    <Card.Header>Data Complexity & Integration</Card.Header>
                    <Card.Body>
                      <Card.Text>
                        Real-world energy datasets require complex hybrid AI-Quantum models for accurate predictions.
                      </Card.Text>
                      <ProgressBar variant="warning" now={60} label="Challenge Level" />
                    </Card.Body>
                  </Card>
                  
                  <Card className="mb-4">
                    <Card.Header>Computational Cost & Scalability</Card.Header>
                    <Card.Body>
                      <Card.Text>
                        Running large-scale quantum simulations demands high-performance quantum hardware and cloud-based solutions.
                      </Card.Text>
                      <ProgressBar variant="info" now={50} label="Challenge Level" />
                    </Card.Body>
                  </Card>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>

     
    </div>
   
  )
}

export default FirstPage;
